import React, { useEffect, useState } from 'react';
import { Form, FormControlProps } from 'react-bootstrap';

interface DebounceInputProps extends Omit<FormControlProps, 'onChange'| 'value'> {
    value: string
    onChange: (value: string) => void;
    debounce?: number;
    immediateAction: () => void;
};

export default function DebouncedInput({ value: initialValue, onChange, immediateAction, debounce = 500, ...props }: DebounceInputProps) {

    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    useEffect(() => { immediateAction() }, [immediateAction]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value);
        }, debounce);

        return () => clearTimeout(timeout);
    }, [debounce, onChange, value]);

    return (
        <Form.Control {...props} value={value} onChange={(e) => setValue(e.target.value)} />
    );
}